import * as outstream from './Outstream'

/**
 * Adapt our local media config into the more verbose prebid mediaTypes config
 * @param media media config { types: ['BANNER'], sizes: [[300,250]]}
 * @param bidders bidders config in prebid compatible format
 * @param slots array of AdSlot objects describing target nodes
 * @returns {[]} list of ad units in prebid format
 */
export function toPrebidUnits (media, bidders, slots, maxSize) {
  const units = []

  for (const slot of slots) {
    const unit = {
      code: slot.nodeId(),
      bids: bidders,
      mediaTypes: { }
    }

    unit.mediaTypes = media

    // prebid will ignore bids if we omit a renderer entry even if this isnt used
    if (unit.mediaTypes.video /* && unit.mediaTypes.context === 'outstream' add this from server resp */) {
      unit.renderer = {
        url: outstream.PLAYER_SRC,
        render: outstream.playVideo
      }
    }

    units.push(unit)
  }

  return units
}
